// Cms Files
import { routeGroup } from '#/routing/routes';

export const cmsViewFileRoute = routeGroup.route('files/*', ['download']);
